<template>
<div class="love-hate">
  <div class="az-search">
    <div class="alpha-list">
      <ul class="alphabet">
        <li v-for="letter in letters" v-bind:key="letter.letter_number" v-bind:class="{ active: isLetterActive(letter.letter_number) }">
          <a v-on:click.stop.prevent="filterByLetter(letter.char, letter.letter_number)">{{letter.char}}</a>
        </li>
      </ul>
      <div class="search-box">
        <div class="news-search">
          <form action="/celebrities/search" method="get">
            <svg width="19" height="33" class="search-icon">
              <use xlink:href="#search"></use>
            </svg>
            <input type="text" id="text_field" class="search-query" v-model="search" v-on:input="filterByKeyword()" />
            <button class="chevron-right" title="Αναζήτηση">
              <svg width="15" height="33">
                <use xlink:href="#chevron-right"></use>
              </svg>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="sorting-block">
    <div class="sorting-wrapper">
      <span class="svg icons">
        <svg width="15" height="35">
          <use xlink:href="#sort"></use>
        </svg>
        <svg width="15" height="35">
          <use xlink:href="#heart"></use>
        </svg>
      </span>
      <multiselect :options="sortingOptions" @input="sort()" v-model="sorting" placeholder="Ταξινόμηση" :searchable="false" :allow-empty="false" label="label" track-by="value"></multiselect>
      <span class="svg chevron">
        <svg width="12" height="35">
          <use xlink:href="#chevron-down"></use>
        </svg>
      </span>
    </div>
    <button class="more-btn filter-total" v-on:click.stop.prevent="removeFilters()" v-if="letter">
      <svg width="50" height="50">
        <use xlink:href="#chevron-right"></use>
      </svg>
      <span>Εμφάνιση όλων</span>
    </button>
  </div>
  <span v-if="search && items.length < 1" class="filter-noresults">Δεν βρέθηκαν αποτελέσματα για την λέξη {{search}}</span>
  <div class="items-block">
    <div v-for="item in rows" v-show="item.active" v-bind:key="item.id" v-bind:class="item.voted ? 'item-block got-' + item.voted: 'item-block'">
      <div class="item-link">
        <div class="item-media">
          <div class="item-media-inner" v-bind:style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
          <div class="item-media-circle" v-bind:style="{ backgroundImage: 'url(' + item.image + ')' }">
            <svg v-if="item.voted" width="40" height="40">
              <use v-bind:xlink:href="item.voted === 'up' ? '#heart-full' : '#close'"></use>
            </svg>
          </div>
        </div>
        <div class="item-info">
          <h3 class="item-title">{{item.title}}</h3>
        </div>
        <div class="item-buttons">
          <button class="btn-love btn-vote" v-on:click.stop.prevent="vote(item, 'love')" v-bind:disabled="item.voted">
            <svg width="20" height="35">
              <use xlink:href="#heart"></use>
            </svg>
            <span class="vote-results for-up">
              <span class="counter">{{item.up}}</span>
            </span>
          </button>
          <button class="btn-hate btn-vote" v-on:click.stop.prevent="vote(item, 'hate')" v-bind:disabled="item.voted">
            <svg width="20" height="35">
              <use xlink:href="#close"></use>
            </svg>
            <span class="vote-results for-down">
              <span class="counter">{{item.down}}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import Multiselect from 'vue-multiselect'
export default {
  name: 'LoveAndHate',
  props: {
    options: Object
  },
  components: {
    Multiselect
  },
  data() {
    return {
      items: [],
      letters: [],
      letter: '',
      letterNumber: 0,
      search: '',
      sorting: {
        label: 'Ταξινόμηση',
        value: 'default'
      },
      sortingOptions: [{
        label: 'Περισσότερες θετικές ψήφοι',
        value: 'love'
      }, {
        label: 'Περισσότερες αρνητικές ψήφοι',
        value: 'hate'
      }],
      searches: [new RegExp('ά', 'gi'), new RegExp('έ', 'gi'), new RegExp('ή', 'gi'), new RegExp('ί', 'gi'), new RegExp('ό', 'gi'), new RegExp('ύ', 'gi'), new RegExp('ώ', 'gi')],
      replacements: ['α', 'ε', 'η', 'ι', 'ο', 'υ', 'ω'],
      cache: {},
      offset: 0,
      limit: 32
    }
  },
  mounted: function() {
    this.cache = this.getCache();
    this.options.items.forEach((item, index) => {
      item.ordering = index;
      item.active = true;
      item.voted = this.cache[item.id] ? this.cache[item.id].action : false;
      item.value = this.normalizeText(item.title);
    });
    this.items = this.options.items;
    this.letters = this.options.letters;
    this.pollId = this.options.pollId;
    this.offset += this.limit;

    window.addEventListener('scroll', () => {
      this.onScroll();
    }, {
      passive: true
    });
  },
  computed: {
    rows: function() {
      return this.items.slice(0, this.offset);
    }
  },
  methods: {

    onScroll: function() {

      if (this.letter || this.search) {
        return;
      }
      var rect = this.$el.getBoundingClientRect();
      var paginate = rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      if (paginate) {
        this.offset += this.limit;
      }

    },

    getCache: function() {
      var date = localStorage.getItem('storeItemsDate');
      if (date) {
        var current = new Date(date);
        current.setHours(current.getHours() + 24);
        if (new Date() > current) {
          localStorage.removeItem('storeItems');
          localStorage.removeItem('storeItemsDate');
        }
      }
      var items = JSON.parse(localStorage.getItem('storeItems'));
      if (_.isObject(items)) {
        return items;
      } else {
        return {};
      }
    },

    normalizeText: function(text) {
      for (var i = 0; i < this.searches.length; i++) {
        text = text.replace(this.searches[i], this.replacements[i]);
      }
      return text.toLowerCase();
    },

    filterByKeyword: _.debounce(function() {
      if (!this.search) {
        this.removeFilters();
        return;
      }
      this.offset = this.items.length;
      this.letter = '';
      this.letterNumber = 0;
      var keyword = this.normalizeText(this.search);
      _.forEach(this.items, function(item) {
        item.active = item.value.match(keyword);
      });

    }, 200),

    filterByLetter: function(letter, letterNumber) {
      this.letter = letter;
      this.letterNumber = letterNumber;
      this.offset = this.items.length;
      _.forEach(this.items, function(item) {
        item.active = item.letter24 == letterNumber;
      });

      if(this.isMobile()) {
        window.scrollTo(0,0);
      }
    },

    removeFilters: function() {
      this.letter = '';
      this.letterNumber = 0;
      this.search = '';
      _.forEach(this.items, function(item) {
        item.active = true;
      });
    },

    sort: function() {
      if (this.sorting.value === 'default') {
        this.sortByOrdering();
      } else if (this.sorting.value === 'love') {
        this.sortByLove();
      } else if (this.sorting.value === 'hate') {
        this.sortByHate();
      }
    },

    sortByOrdering: function() {
      this.items = _.orderBy(this.items, 'ordering', 'asc');
    },

    sortByLove: function() {
      this.items = _.orderBy(this.items, 'up', 'desc');
    },

    sortByHate: function() {
      this.items = _.orderBy(this.items, 'down', 'desc');
    },

    vote: function(item, action) {
      item.voted = true;
      if (action === 'love') {
        this.love(item);
      } else if (action === 'hate') {
        this.hate(item);
      }
    },

    love: function(item) {
      item.voted = 'up';
      item.up++;
      var endpoint = '/index.php?option=com_celebrities&task=vote&id=' + item.id + '&act=up&pid=' + this.pollId;
      axios.post(endpoint).then(() => {
        this.updateCache(item.id, 'up');
      }).catch(() => {
        item.voted = false;
        item.up--;
      });
    },

    hate: function(item) {
      item.voted = 'down';
      item.down++;
      var endpoint = '/index.php?option=com_celebrities&task=vote&id=' + item.id + '&act=down&pid=' + this.pollId;
      axios.post(endpoint).then(() => {
        this.updateCache(item.id, 'down');
      }).catch(() => {
        item.voted = false;
        item.down--;
      });
    },

    updateCache: function(id, action) {
      localStorage.setItem('storeItemsDate', new Date());
      this.cache[id] = {
        action: action
      };
      localStorage.setItem('storeItems', JSON.stringify(this.cache));
    },

    isLetterActive: function(letterNumber) {
      return letterNumber == this.letterNumber;
    },

    isMobile: function() {
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

  }
}
</script>
